import type { Step } from '../engine';
import { formatNumber, fullPrecision, unitLabel } from '../ui/format';
import { Ref } from '../ui/kit';
import w from './Workspace.module.css';

const refText = (r: Step['ref']) => [r.eq ? `eq. ${r.eq}` : null, r.table ? `Table ${r.table}` : null, r.figure ? `Fig. ${r.figure}` : null, r.eq || r.table || r.figure ? null : r.clause].filter(Boolean).join(' · ');

/** The working behind a result, step by step, with the clause each step comes from. */
export function Trace({ steps }: { steps: Step[] }) {
  return (
    <ol className={w.trace}>
      {steps.map((s, i) => (
        <li key={`${s.id}:${i}`} className={w.step}>
          <div className={w.stepHead}>
            <span>{s.label}</span>
            <Ref>{refText(s.ref)}{s.ref.md ? ` · ${s.ref.md}` : ''}</Ref>
          </div>
          {Object.keys(s.inputs).length > 0 && (
            <div className={w.stepInputs}>
              {Object.entries(s.inputs).map(([k, q]) => (
                <span key={k} title={`${fullPrecision(q.value)} ${unitLabel(q.unit)}`}><i>{k}</i> {formatNumber(q.value)}{q.unit !== '1' ? ` ${unitLabel(q.unit)}` : ''}</span>
              ))}
            </div>
          )}
          <div className={w.stepOut}>
            <i>{s.output.symbol}</i> ={' '}
            {'text' in s.output ? <b>{s.output.text}</b> : <b title={fullPrecision(s.output.value)}>{formatNumber(s.output.value)}{s.output.unit !== '1' ? ` ${unitLabel(s.output.unit)}` : ''}</b>}
          </div>
          {s.notes?.map((n, j) => (
            <div key={j} className={w.stepNote} data-kind={n.kind}>{n.text}{n.ref?.md ? <Ref> {n.ref.md}</Ref> : null}</div>
          ))}
        </li>
      ))}
    </ol>
  );
}
